import React from "react";

export const ErrorMessage = ({ error, t }) => {
  return (
    <div className="alert alert-danger" role="alert">
      {t("Erreur lors du chargement des données")}
      {error?.message && (
        <div className="mt-2">
          <small>{error.message}</small>
        </div>
      )}
    </div>
  );
};
